import { render, staticRenderFns } from "./SectionContacts.vue?vue&type=template&id=5ae2a40f"
import script from "./SectionContacts.vue?vue&type=script&lang=js"
export * from "./SectionContacts.vue?vue&type=script&lang=js"
import style0 from "./SectionContacts.vue?vue&type=style&index=0&id=5ae2a40f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports